import Swiper, { Navigation, Autoplay, Pagination, EffectFade } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";

function imagesSlider() {
  const isPresent = document.querySelector(".images-slider");
  if (!isPresent) {
    return;
  }

  const slider = new Swiper(".images-slider", {
    modules: [Autoplay, EffectFade, Pagination, Navigation],
    loop: true,
    autoplay: true,
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    keyboard: {
      enabled: true,
    },
    autoHeight: false,
    navigation: {
      nextEl: ".images-slider-next",
      prevEl: ".images-slider-prev",
    },
    pagination: {
      el: ".images-slider-pagination",
      type: "bullets",
      clickable: true,
    },
  });
}

export { imagesSlider };
